var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.isElectron
    ? _c(
        "w-col",
        { staticClass: "downloads" },
        [
          _vm.isWindows
            ? _c(
                "w-button",
                {
                  attrs: {
                    link: "https://winfakt.com/download/wf-online/winfakt-online-setup.exe",
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "mr",
                    attrs: { fab: "", icon: ["fab", "windows"] },
                  }),
                  _vm._v(_vm._s(_vm.$ct("download-win")) + " "),
                ],
                1
              )
            : _vm._e(),
          _vm.isMac
            ? _c(
                "w-button",
                {
                  attrs: {
                    link: "https://winfakt.be/assets/download/winfakt-online-mac.zip",
                  },
                },
                [
                  _c("w-fa", {
                    staticClass: "mr",
                    attrs: { fab: "", icon: ["fab", "apple"] },
                  }),
                  _vm._v(_vm._s(_vm.$ct("download-mac")) + " "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }